export default function SectionContact() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-mail-send-fill text-primary-400 text-xs"></i></span>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">联系我们</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">联系投稿</h2>
          <p className="text-sm text-foreground-400 mb-8">
            有好片推荐？想投稿影评？欢迎通过以下方式联系我们，夜猫影院期待你的声音
          </p>

          <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center gap-6 justify-center">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-mail-line text-primary-400 text-lg"></i>
                </span>
                <div className="text-left">
                  <p className="text-xs text-foreground-400">投稿邮箱</p>
                  <p className="text-sm text-foreground-100 font-medium">submit@nightcatcinema.film</p>
                </div>
              </div>
              <div className="hidden sm:block w-px h-10 bg-background-300"></div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10">
                  <i className="ri-wechat-line text-accent-400 text-lg"></i>
                </span>
                <div className="text-left">
                  <p className="text-xs text-foreground-400">合作微信</p>
                  <p className="text-sm text-foreground-100 font-medium">NightCatCinema</p>
                </div>
              </div>
              <div className="hidden sm:block w-px h-10 bg-background-300"></div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-500/10">
                  <i className="ri-time-line text-secondary-400 text-lg"></i>
                </span>
                <div className="text-left">
                  <p className="text-xs text-foreground-400">响应时间</p>
                  <p className="text-sm text-foreground-100 font-medium">24小时内回复</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}